<template>
  <b-card-code>
    <validation-observer ref="simpleRules">
      <b-form @submit.prevent="submitForm">
        <b-row>
          <b-col md="4">
            <b-form-group>
              <label>Bank Name</label>
              <label style="color: red !important">*</label>
              <validation-provider
                #default="{ errors }"
                name="Bank Name"
                rules="required"
              >
                <b-form-input
                  v-model="bankname"
                  placeholder="Enter Bank Name"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Branch Name</label>
              <label style="color: red !important">*</label>
              <validation-provider
                #default="{ errors }"
                name="Branch Name"
                rules="required"
              >
                <b-form-input
                  v-model="branchname"
                  placeholder="Enter Branch Name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Account Name</label>
              <label style="color: red !important">*</label>
              <validation-provider
                #default="{ errors }"
                name="Account Name"
                rules="required"
              >
                <b-form-input
                  v-model="accountname"
                  placeholder="Enter Account Name "
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Account No</label>
              <label style="color: red !important">*</label>
              <validation-provider
                #default="{ errors }"
                name="Account No"
                rules="required"
              >
                <b-form-input
                  v-model="accountno"
                  type="number"
                  placeholder="Enter Account No"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>MICR Code</label>
              <label style="color: red !important">*</label>
              <validation-provider
                #default="{ errors }"
                name="MICR Code"
                rules="required"
              >
                <b-form-input
                  v-model="micrcode"
                  placeholder="Enter MICR Code"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>IFSC Code</label>
              <label style="color: red !important">*</label>
              <validation-provider
                #default="{ errors }"
                name="IFSC Code"
                rules="required"
              >
                <b-form-input
                  v-model="ifsccode"
                  maxlength="11"
                  @input="validateIFSCCodeClick($event)"
                  placeholder="Enter IFSC Code"
                />
                <small v-if="ifsccodeValidate == false" class="text-danger"
                  >Enter Valid IFSC Code</small
                >
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Default</label>
              <v-select
                v-model="Default"
                placeholder="None"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="['Yes', 'No']"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-button
              class="mt-1"
              variant="primary"
              type="submit"
              @click.prevent="submitForm"
              :disabled="flag"
            >
              Submit
            </b-button>
            <b-button
              class="mt-1 ml-2"
              variant="primary"
              type="submit"
              @click="handleBack"
            >
              Back
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card-code>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import BCardCode from "@core/components/b-card-code";
import PinchScrollZoom from "@coddicat/vue-pinch-scroll-zoom";
import {
  BFormInput,
  BFormFile,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BFormTextarea,
  BFormDatepicker,
  BImgLazy,
  BTable,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
  min_value,
} from "@validations";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import axios from "axios";
import moment from "moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    PinchScrollZoom,
    Datepicker,
    BFormFile,
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    vSelect,
    BFormDatepicker,
    BFormTextarea,
    BImgLazy,
    BTable,
  },
  data() {
    return {
      bankname: "",
      branchname: "",
      accountname: "",
      accountno: "",
      micrcode: "",
      ifsccode: "",
      ifsccodeValidate: true,
      Default: "",

      accessToken: localStorage.getItem("accessToken"),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      ifEdit: false,
      flag: false,
    };
  },
  mounted() {
    const userData = JSON.parse(localStorage.getItem("UserRights"));
    const role = JSON.parse(localStorage.getItem("userData")).role;
    if (role !== "admin") {
      userData.map((item) => {
        if (item.modulename == "Bankaccount") {
          if (this.$route.params.id) {
            if (item.edit !== 1) {
              this.$router.push("/master/account/bankaccount");
            }
          } else if (item.add !== 1) {
            this.$router.push("/master/account/bankaccount");
          }
        }
      });
    }
    this.ifEdit = !!this.$route.params.id;
    this.ifEdit && this.getEditValue();
  },
  methods: {
    async getEditValue() {
      axios({
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getbankById/${this.$route.params.id}`,
      }).then((response) => {
        this.getEditItems(response.data.data);
      });
    },
    getEditItems(item) {
      item.map((item) => {
        this.bankname = item.bankname;
        this.branchname = item.branchname;
        this.accountname = item.accountname;
        this.accountno = item.accountno;
        this.micrcode = item.micrcode;
        this.ifsccode = item.ifsccode;
        this.Default = item.Default;
      });
    },
    validateIFSCCodeClick(e) {
      const regex = new RegExp(/^[A-Z]{4}0[A-Z0-9]{6}$/);
      this.ifsccode = this.ifsccode.toUpperCase();
      if (regex.test(this.ifsccode) == true) {
        this.ifsccodeValidate = true;
      } else {
        this.ifsccodeValidate = false;
      }
    },
    submitForm(e) {
      const obj = {
        bankname: this.bankname,
        branchname: this.branchname,
        accountname: this.accountname,
        accountno: this.accountno,
        micrcode: this.micrcode,
        ifsccode: this.ifsccode,
        Default: this.Default,
      };
      const ifEdit = !!this.$route.params.id;
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success == false) {
          this.$swal({
            title: "Warning",
            timer: 5000,
            text: "Plese Fill the Required Field",
            icon: "warning",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        }
        const accessToken = localStorage.getItem("accessToken");
        const baseApi = process.env.VUE_APP_APIENDPOINT;
        if (success) {
          this.flag = true;
          await axios({
            method: `${this.ifEdit ? "put" : "post"}`,
            url: this.ifEdit
              ? `${baseApi}/bank/${this.$route.params.id}`
              : `${baseApi}/bank`,
            headers: {
              "content-type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
            data: JSON.stringify(obj),
          })
            .then((json) => {
              this.flag = false;

              if (json.data.status == 200 || json.data) {
                this.$swal({
                  title: "Submited",
                  text: json.data.message
                    ? `${json.data.message}`
                    : "Update SuccessFully",
                  icon: "success",
                  timer: 5000,
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                  buttonsStyling: false,
                });
              }
              this.$router.push("/master/account/bankaccount");
            })
            .catch((error) => {
              this.flag = false;

              this.$swal({
                title: "Error!",
                text: `${error}`,
                icon: "error",
                timer: 5000,
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    handleBack() {
      this.$router.push("/master/account/bankaccount");
    },
  },
};
</script>
